import { Link } from 'react-router-dom';
import { StatusUI, StatusEnum } from '@brandbank/portal-components';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import { paths } from 'features/routing';
import {
  FavouriteFeedButton,
  useFavouriteFeedActions,
} from 'features/favourite-feeds';
import { AxiosError } from 'axios';

type FeedDetailsLayoutErrorProps = {
  error: AxiosError | null;
  purposeId: number;
  purposeName: string;
};

const FeedDetailsLayoutError = ({
  error,
  purposeId,
  purposeName,
}: FeedDetailsLayoutErrorProps) => {
  const notAuthorised = error && error.response?.status === 401;
  const { isFavourited } = useFavouriteFeedActions(purposeId, purposeName);

  return (
    <StatusUI
      action={
        <>
          {notAuthorised && isFavourited && (
            <Box sx={{ my: 2 }}>
              <FavouriteFeedButton
                purposeId={purposeId}
                purposeName={purposeName}
              />
            </Box>
          )}

          <Button
            color='error'
            component={Link}
            to={paths.feeds}
            variant='outlined'
          >
            Back to feeds
          </Button>
        </>
      }
      splashPage
      status={StatusEnum.ERROR}
      subtitle={error?.message}
    />
  );
};

export default FeedDetailsLayoutError;
